var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSackDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13769_260778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8438 1.77188L10.3938 4.3125C13.0156 6.70312 15.5 9.11562 15.5 13.025C15.5 14.6687 14.1687 16 12.525 16H3.475C1.83125 16 0.5 14.6687 0.5 13.025C0.5 9.11562 2.98437 6.70312 5.60625 4.3125L4.15625 1.77188C4.05312 1.59375 4 1.39062 4 1.18438C4 0.53125 4.53125 0 5.18437 0H10.8156C11.4688 0 12 0.53125 12 1.18438C12 1.39062 11.9469 1.59375 11.8438 1.77188ZM7.08125 5L7.05312 5.02812C4.19375 7.6375 2 9.64375 2 13.025C2 13.8406 2.65937 14.5 3.475 14.5H12.525C13.3406 14.5 14 13.8406 14 13.025C14 9.64062 11.8062 7.6375 8.94687 5.025L8.91875 4.99687H7.08437L7.08125 5ZM6.86875 3.5H9.12813L10.2719 1.5H5.72813L6.87187 3.5H6.86875ZM8.125 6.5C8.46875 6.5 8.75 6.78125 8.75 7.125V7.25H9C9.34375 7.25 9.625 7.53125 9.625 7.875C9.625 8.21875 9.34375 8.5 9 8.5H7.51562C7.3 8.5 7.125 8.675 7.125 8.89062C7.125 9.08125 7.2625 9.24375 7.45 9.275L8.75313 9.49375C9.54375 9.625 10.125 10.3094 10.125 11.1125C10.125 11.9281 9.53125 12.6031 8.75 12.7312V12.8781C8.75 13.2219 8.46875 13.5031 8.125 13.5031C7.78125 13.5031 7.5 13.2219 7.5 12.8781V12.7531H6.75C6.40625 12.7531 6.125 12.4719 6.125 12.1281C6.125 11.7844 6.40625 11.5031 6.75 11.5031H8.48438C8.7 11.5031 8.875 11.3281 8.875 11.1125C8.875 10.9219 8.7375 10.7594 8.55 10.7281L7.24687 10.5094C6.45625 10.3781 5.875 9.69375 5.875 8.89062C5.875 7.99062 6.6 7.25938 7.5 7.25V7.125C7.5 6.78125 7.78125 6.5 8.125 6.5Z",
    fill: "#1D1F2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13769_260778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSackDollar);
export default __webpack_public_path__ + "static/media/sack-dollar.2b9847491b78201bf804649465de2aa5.svg";
export { ForwardRef as ReactComponent };